import React, { Component } from 'react';
import { connect } from 'react-redux';

export class ScorecardHeader extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      scorecardHeader: props.scHeader,
      toolTipText: props.scToolTipText
    }
  }

  render() {
    return (
      <div className="scard-header">
        <span className="scard-header-text">
              {this.state.scorecardHeader}
        </span>
        {/* <span className="tooltip_holder">
          <span className="tooltiptext">{this.state.toolTipText}</span>
        </span> */}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScorecardHeader);



// WEBPACK FOOTER //
// ./src/features/scorecard/ScorecardHeader.js